export var TimeKind;
(function (TimeKind) {
    TimeKind["PAST"] = "past";
    TimeKind["NOW"] = "now";
    TimeKind["FUTURE"] = "future";
    TimeKind["TODAY"] = "today";
})(TimeKind || (TimeKind = {}));
//# sourceMappingURL=time-kind.js.map